import { connect } from 'react-redux';

const mapStateToProps = ({ SelectedCategoriesData }) => ({ SelectedCategoriesData });

export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
